import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditModemTypeForm from './forms/EditModemTypeForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { updateModemTypeAction } from '../actions/modemTypesActions'
import { createQueryString } from '../utils/queryParams'

class EditModemType extends Component {
  static propTypes = {
    modemType: PropTypes.object.isRequired,
    getModemType: PropTypes.func.isRequired,
    carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
    getAllCarriers: PropTypes.func.isRequired,
    isModemTypeLoading: PropTypes.bool,
    match: PropTypes.object,
  }

  componentDidMount() {
    const { getModemType, getAllCarriers, match } = this.props
    getAllCarriers(createQueryString({ perPage: 'all' }))
    getModemType(match.params.id)
  }

  render() {
    const { modemType, carriers, isModemTypeLoading } = this.props
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/modems">Modems</Anchor>,
      'Edit Modem Type',
    ]

    return (
      <section className="EditModemType">
        <FormHeader crumbs={crumbs} />
        <EditModemTypeForm
          submitAction={updateModemTypeAction}
          initialValues={modemType}
          carriers={carriers}
          isModemTypeLoading={isModemTypeLoading}
          enableReinitialize
        />
      </section>
    )
  }
}

export default EditModemType
